import type { Metadata } from "metabase-types/metadata";
import { t } from "ttag";

import { Button, Icon } from "metabase/ui";
import type { Card, Dataset } from "metabase-types/api";
import type { QueryBuilderMode } from "metabase-types/store";

interface QuestionReportModelWidgetProps {
  onEditReportModel: () => void;
  className?: string;
}

export function QuestionReportModelWidget({
  onEditReportModel,
  className,
}: QuestionReportModelWidgetProps) {
  return (
    <Button
      className={className}
      leftSection={<Icon name="table2" />}
      onClick={onEditReportModel}
    >
      {t`Report Model`}
    </Button>
  );
}

QuestionReportModelWidget.shouldRender = ({
  queryBuilderMode,
  isObjectDetail,
  metadata,
  card,
}: {
  queryBuilderMode: QueryBuilderMode;
  isObjectDetail: boolean;
  metadata: Metadata;
  card: Card;
  result?: Dataset;
}) => {
  const sourceTable = card?.dataset_query?.query?.["source-table"];
  const tableName = sourceTable ? metadata?.tables?.[sourceTable]?.name : "";

  return (
    queryBuilderMode === "view" &&
    tableName &&
    !tableName.startsWith("dataset_") &&
    !tableName.endsWith("system_data") &&
    !isObjectDetail
  );
};
